import React, { FC, useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { UseIncomeSourceFormArgs, useIncomeSourceForm } from '../hooks';

interface IncomeSourceFormProps extends UseIncomeSourceFormArgs {
  children?: React.ReactNode;
  className?: HTMLFormElement['className'];
  registerSubmit?: (submitFn: () => void) => void; // New prop
}

export const IncomeSourceFormProvider: FC<IncomeSourceFormProps> = ({
  children,
  className,
  registerSubmit,
  ...useIncomeSourceFormArgs
}) => {
  const { formMethods, onSubmit } = useIncomeSourceForm(useIncomeSourceFormArgs);

  useEffect(() => {
    if (registerSubmit) {
      const handleSubmit = () => formMethods.handleSubmit(onSubmit)();
      registerSubmit(handleSubmit);
    }
  }, []);

  return (
    <FormProvider {...formMethods}>
      <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
};
